
export const SelectionSideMapping = {
    Over: 1,
    Home: 1,
    Draw: 2,
    Tie: 2,
    Under: 3,
    Away: 3
}
